import { useQuery } from "@tanstack/react-query";
import { adaptCarouselBanners } from "src/features/vendorSponsorship/adapters/adaptCarouselBanners";
import cmsClient from "src/services/cmsClient";

const fetchBannerLibrary = async () => {
	const response = await cmsClient.get<IBanner[]>(
		"/homepage/admin/promotion/",
		{
			params: {
				published: false,
			},
		}
	);

	return response.data;
};

interface Options {
	onSuccess?: (banners: Banner[]) => void;
}

const usePromotionBannerLibrary = (options: Options = {}) => {
	const query = useQuery(["promotion-banner-library"], fetchBannerLibrary, {
		select: adaptCarouselBanners,
		...options,
	});

	return query;
};

export default usePromotionBannerLibrary;
